import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-background-overlay-drawer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './background-overlay-drawer.component.html',
  styleUrl: './background-overlay-drawer.component.scss'
})
export class BackgroundOverlayDrawerComponent {
  constructor() {}

  @Input() isOpen = false;

}
